import type { SVGProps } from 'react';

export const Inquiry = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.24 7.76004C15.6646 7.18121 14.977 6.72588 14.2195 6.42191C13.462 6.11795 12.6504 5.97175 11.8344 5.99225C11.0184 6.01275 10.2152 6.19953 9.47391 6.54115C8.7326 6.88277 8.0688 7.37205 7.5231 7.97906C6.97741 8.58607 6.56131 9.29803 6.30025 10.0714C6.0392 10.8448 5.93868 11.6633 6.00486 12.4768C6.07103 13.2903 6.30251 14.0818 6.68512 14.8028C7.06772 15.5238 7.59342 16.1592 8.23004 16.67"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9028 10.0375C12.5976 10.3176 12.5773 10.7921 12.8574 11.0972C13.1375 11.4024 13.6119 11.4227 13.9171 11.1426L13.4099 10.5901L12.9028 10.0375ZM20.0072 5.55253L20.5597 5.04537L19.5454 3.94031L18.9928 4.44747L19.5 5L20.0072 5.55253ZM13.4099 10.5901L13.9171 11.1426L20.0072 5.55253L19.5 5L18.9928 4.44747L12.9028 10.0375L13.4099 10.5901Z"
        fill="currentColor"
      />
      <path
        d="M12 1C15.0376 1 17.7877 2.23107 19.7783 4.22168L18.7178 5.28223C16.9986 3.56306 14.6234 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 10.9063 21.3127 9.85671 20.9727 8.87891L22.3896 8.38574C22.7835 9.518 23 10.7336 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1Z"
        fill="currentColor"
      />
    </svg>
  );
};
